import { useState } from "react";
import { openBillingPortal } from "@/lib/api";
import { toast } from "sonner";

export default function BillingPortalButton({
  returnPath = "/parent",
  className = "nb-button px-4 py-2",
  children = "Manage billing",
  testId = "billing-portal-btn",
}) {
  const [loading, setLoading] = useState(false);

  const open = async () => {
    setLoading(true);
    try {
      const { portal_url } = await openBillingPortal(window.location.origin + returnPath);
      window.location.href = portal_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn&apos;t open billing portal");
      setLoading(false);
    }
  };

  return (
    <button data-testid={testId} onClick={open} disabled={loading} className={className}>
      {loading ? "Opening…" : children}
    </button>
  );
}
